module.exports = __webpack_public_path__ + "static/img/5.4adc0e1b.png";